import { BOOKING_DEFAULTS } from "@/modules/Booking/constants/booking.constants";
import type {
  GroupAirline,
  GroupApiFlight,
  GroupApiItem,
  GroupFlight,
  GroupItem,
} from "../types";

const getAirlineFromFlightNumber = (flightNumber: string): GroupAirline => {
  const code = (flightNumber.split("-")[0] || "").trim().toUpperCase();
  return {
    code,
    logo: code
      ? `${BOOKING_DEFAULTS.AIRLINE_LOGO_BASE_URL}${code}.png`
      : BOOKING_DEFAULTS.DEFAULT_AIRLINE_IMAGE_URL,
  };
};

const mapGroupFlight = (flight: GroupApiFlight): GroupFlight => ({
  ...flight,
  flight_number: flight.flight_number || "",
  airline:
    flight.airline ?? getAirlineFromFlightNumber(flight.flight_number || ""),
});

export const mapGroup = (group: GroupApiItem): GroupItem => ({
  ...group,
  tags: group.tags ?? [],
  flights: (group.flights ?? []).map(mapGroupFlight),
  token_amount: group.token_amount ?? null,
  selling_price_per_seat_adult: group.selling_price_per_seat_adult ?? null,
  selling_price_per_seat_child: group.selling_price_per_seat_child ?? null,
  selling_price_per_seat_infant: group.selling_price_per_seat_infant ?? null,
});
